export const zIndicies = {
	DRAWER: "z-[1205]",
	DIALOG: "z-[1210]",
	SELECT: "z-[1400]",
	TOOLTIP: "z-[1400]",
	NOTIFICATION: "z-[2000]",
};
